import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { HolidayHours } from '../types';

import { schema } from '../utils/schema';

import { HOLIDAY_HOURS } from 'RestAPIs/endpoints';
import { useUpdateResource } from 'RestAPIs/useUpdateResource';

import { LoadingButton } from '@mui/lab';
import Box from '@mui/material/Box';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import TextField from 'components/shared/ControlledFields/ControlledTextField';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import PeriodTypeSvcSelect from './PeriodTypeSvcSelect';

const HolidayHoursEditForm = ({
  rowData,
  handleClose
}: FormComponentProps<HolidayHours>) => {
  const { t } = useTranslation('common');
  const { mutateAsync: save, isLoading } = useUpdateResource({
    url: HOLIDAY_HOURS,
    id: rowData?.periodSetupId ?? '',
    invalidateQueryKey: ['holidayHours', 'list']
  });

  const methods = useForm({
    defaultValues: rowData ? schema.cast(rowData) : undefined,
    resolver: yupResolver(schema),
    mode: 'onChange'
  });
  const { control } = methods;

  const onSubmit = (data) => {
    save(data).then(handleClose);
  };

  return (
    <>
      <MultiStepForm methods={methods} onSubmit={onSubmit}>
        <MultiStepForm.Section title={t('holidayHours.sectionTitle.basis')}>
          <TextField
            label={t('holidayHours.grid.pYear')}
            control={control}
            name="pYear"
            variant="outlined"
            disabled
          />
          <TextField
            label={t('holidayHours.grid.pPeriod')}
            control={control}
            name="pPeriod"
            type="number"
            variant="outlined"
            disabled
          />
          <PeriodTypeSvcSelect disabled />
        </MultiStepForm.Section>
        <MultiStepForm.Section
          title={t('holidayHours.sectionTitle.daysAndHours')}
        >
          <TextField
            label={t('holidayHours.grid.socialSecurityDays')}
            control={control}
            name="socialSecurityDays"
            type="number"
            variant="outlined"
          />
          <TextField
            label={t('holidayHours.grid.holidayHours')}
            control={control}
            name="holidayHours"
            type="number"
            variant="outlined"
          />
        </MultiStepForm.Section>
        <MultiStepForm.Actions>
          <Box display="flex" ml="auto">
            <LoadingButton
              loading={isLoading}
              type="submit"
              variant="contained"
              autoFocus
              color="dark"
            >
              {t('save')}
            </LoadingButton>
          </Box>
        </MultiStepForm.Actions>
      </MultiStepForm>
    </>
  );
};

export default HolidayHoursEditForm;
